$(document).ready(function(){
var Shopify = Shopify || {};
  
console.log(Shopify);
 
  //var getecurre = $('.getcurrency').html();
  //alert(getecurre);
  
Shopify.money_format = "${{amount}}";
  
  
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
  

$('.site-header__cart').click(function(e){
  e.preventDefault();
  window.location.href = "/cart";
  //$('.cart-flyout').addClass('drawer_open');
  //$('body').addClass('cart-drawer-open ');
});
$(document).on('click', '.cart-close', function(){
   $('.cart-flyout').removeClass('drawer_open');
  $('body').removeClass('cart-drawer-open ');
  
});
  
$(document).click(function (e) {
  if (!$(e.target).closest('.cv_cart_drawer, .product-form__cart-submit, .site-header__cart').length) {
   $('.cart-flyout').removeClass('drawer_open');
  $('body').removeClass('cart-drawer-open ');

  }
});
  
$(document).click(function (e) {
  if (!$(e.target).closest('.cv_cart_drawer, .rk__add_to_cart, .site-header__cart').length) {
   $('.cart-flyout').removeClass('drawer_open');
  $('body').removeClass('cart-drawer-open ');

  }
});

/**********ADD TO CART *************/
$('.product-form__cart-submit').click(function(e){
  	  e.preventDefault();
  
  
  var seleoptionId = $('#seleoptionId').find(":selected").val();
  //alert(seleoptionId);
  if(seleoptionId != '' && seleoptionId != undefined){
    var varid = $('#seleoptionId').find(":selected").val();
    var varqty = $('#product-quantity-select').find(":selected").val();
    //alert(varid);
    var data = {
      "id": varid,
      "quantity": varqty
    }
    
     $.ajax({
      type: 'POST', 
      url: '/cart/add',
      dataType: 'html', 
      data: data,
      success:function(response){
       
        $('.cart-flyout').html($(response).filter('.cart-flyout').html()).addClass('drawer_open');
        $('.site-header__cart').html($(response).find('.site-header__cart').html());
		$('body').addClass('cart-drawer-open ');
        setTimeout(function(){ 
          $('.cart-close').trigger('click');
        }, 3000);
      }
	});
    
  }else{
   
     var varid = $('#selId').val();
      //alert(varid);
      var varqty = $('#product-quantity-select').find(":selected").val();
      var data = {
      "id": varid,
      "quantity": varqty
      }
      
      $.ajax({
      type: 'POST', 
      url: '/cart/add',
      dataType: 'html', 
      data: data,
      success:function(response){
       
        $('.cart-flyout').html($(response).filter('.cart-flyout').html()).addClass('drawer_open');
        $('.site-header__cart').html($(response).find('.site-header__cart').html());
		$('body').addClass('cart-drawer-open');
         setTimeout(function(){ 
          $('.cart-close').trigger('click');
         }, 3000);
      }
	});
  }
  
   //alert(conceptName);
   //alert(varid);
    
   //return false;
   
   
});

                                                                                                         
                                                                                                                   
/********* REMOVE BUTTON **********/
$(document).on("click",".custom-cart-remove-btn",function(e){e.preventDefault();var t=$(this).attr("href");$.ajax({url:t,type:"GET",success:function(response){
  $('.cart-flyout').html($(response).filter('.cart-flyout').html()).addClass('drawer_open');
          $('.site-header__cart').html($(response).find('.site-header__cart').html());
  }});
                                                            });
         
/**************QUANTITY****************/

$(document).on('click','.qtyplus',function(e){
//  console.log('testt');
  var line = $(this).attr('data-line');
 var var_id = $(this).attr('data-var-id');
  $(this).parents('.cart__qty').find('.cart__qty-input').val(+$(this).parents('.cart__qty').find('.cart__qty-input').val() +1);
  var update_qty_val =  $(this).parents('.cart__qty').find('.cart__qty-input').val();
  console.log('update_qty_val ' +update_qty_val);
  var data = { "quantity": update_qty_val, "id": var_id }
       $.ajax({
         type: 'POST',
         url: '/cart/change.js',
         data: data,
         dataType: 'json',
         success: function(data) { 
          console.log(data);
            $('.cart__subtotal').html(Shopify.formatMoney(data.total_price))                                                        

           $('#CartCount span').html(data.item_count);                          
                                      }
                                                                                             
       });
         });
           
           $(document).on('click','.qtymin',function(e){
//  console.log('testt');
  var line = $(this).attr('data-line');
 var var_id = $(this).attr('data-var-id');
  		if ($(this).next().val() > 0) {
    	   if ($(this).next().val() > 0) $(this).next().val(+$(this).next().val() - 1);
		}
  var update_qty_val = $(this).next().val();
  //alert(update_qty_val);
             
             
  console.log('update_qty_val ' +update_qty_val);
  var data = { "quantity": update_qty_val, "id": var_id }
       $.ajax({
         type: 'POST',
         url: '/cart/change.js',
         data: data,
         dataType: 'json',
         success: function(data) { 
          console.log(data);
            $('.cart__subtotal').html(Shopify.formatMoney(data.total_price))                                                        

               $('#CartCount span').html(data.item_count);                                   
                                      }
                                                                                             
       });
             
             if(update_qty_val == 0){
               //alert('ddf');
               $(this).closest('.cart-custom-tr').find(".custom-cart-remove-btn").click();
             }
         });
         $(document).ready(function(){
         $('.cv_search_icon').click(function(){
         $(this).parents('.site-header__search').addClass('search_open')
       })
       $('.cv_search_cross').click(function(){
         $(this).parents('.site-header__search').removeClass('search_open')
       })
});
  
});

$(document).on('click','.rk__add_to_cart',function(e){
   e.preventDefault();
  var varid = $('.rk__input_id').val();
  var qtyid = $('.rk__quantity_input').val();
   //alert(varid);
  //alert(qtyid);
  
     var data = {
      "id": varid,
      "quantity": qtyid
    }
    
     $.ajax({
      type: 'POST', 
      url: '/cart/add',
      dataType: 'html', 
      data: data,
      success:function(response){
       
        $('.cart-flyout').html($(response).filter('.cart-flyout').html()).addClass('drawer_open');
        $('.site-header__cart').html($(response).find('.site-header__cart').html());
		$('body').addClass('cart-drawer-open');
         setTimeout(function(){ 
          $('.cart-close').trigger('click');
         }, 3000);
      }
	});
});